import { AddressFormValues } from '../../types';
import { capitalizeEveryWord } from '../../utils';

export const FacilityRow = ({
  employer,
  address,
  location: locationFallback,
}: {
  employer: string;
  address?: AddressFormValues;
  location?: string;
}) => {
  const parts = [
    address?.city?.trim() ? capitalizeEveryWord(address.city.trim()) : '',
    address?.countryCode?.value?.trim() || '',
  ].filter(Boolean);
  const trimmedFallback = locationFallback?.trim();
  const location = parts.length ? parts.join(', ') : trimmedFallback || 'Facility Not Specified';
  return (
    <div className="w-full text-left leading-tight">
      <div>{employer}</div>
      <div>{location}</div>
    </div>
  );
};
